import React, {useState} from 'react';
import {StorageObject} from '../../../models/StorageObject';
import {StorageObjectDTO} from '../../../models/dto/StorageObjectDTO';
import {useGetStorageObject} from '../../../hooks/UseGetStorageObject';
import {CreateFolderSelectionDialog} from './CreateFolderSelectionDialog';
import {FolderMetaDataDialog} from './FolderMetaDataDialog';
import {getPath, isValidText} from '../../../utils';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import {FolderDialogProps} from '../StorageObjectDialogProps';

/**
 * @name CreateEditFolderDialog
 * @description
 * The dialog to create a new folder or edit an existing one
 */
export const CreateEditFolderDialog: React.VFC<FolderDialogProps> = (props) => {
    const getStorageObject = useGetStorageObject();
    const [selectedName, setSelectedName] = useState<string>(props.item ? props.item.name : '');
    const [editedItem, setEditedItem] = useState<StorageObject | null>(props.item);

    const handleOnSave = (storageObjectDTO: StorageObjectDTO, addMore: boolean) => {
        props.onSave(storageObjectDTO, addMore);
    };

    const validateName = (name: string): boolean => {
        return (isValidText(name) && (name.trim().length > 0)) as boolean;
    };

    const onContinueHandler = async (name: string) => {
        let nameInput = name;
        if (validateName(name)) {
            nameInput = name.trim();
            let path = getPath(props.currentPath, nameInput);
            setEditedItem(await getStorageObject(encodeURI(path)));
        }

        setSelectedName(nameInput);
    };

    const renderDialogs = () => {
        if (editedItem) {
            return (
                <FolderMetaDataDialog item={editedItem}
                                      name={editedItem.name}
                                      breadcrumbs={props.breadcrumbs}
                                      currentPath={props.currentPath}
                                      parentOwnerRoles={props.parentOwnerRoles}
                                      parentRoles={props.parentRoles}
                                      parentLocales={props.parentLocales}
                                      language={props.language}
                                      defaultLocale={props.defaultLocale}
                                      rolesDataSource={props.rolesDataSource}
                                      onClose={props.onClose}
                                      onSave={handleOnSave}/>
            );
        } else if (!selectedName) {
            return (
                <CreateFolderSelectionDialog breadcrumbs={props.breadcrumbs}
                                             currentPath={props.currentPath}
                                             onClose={props.onClose}
                                             onContinue={onContinueHandler}/>
            );
        } else {
            return (
                <FolderMetaDataDialog item={editedItem}
                                      name={selectedName}
                                      breadcrumbs={props.breadcrumbs}
                                      currentPath={props.currentPath}
                                      parentOwnerRoles={props.parentOwnerRoles}
                                      parentRoles={props.parentRoles}
                                      parentLocales={props.parentLocales}
                                      language={props.language}
                                      defaultLocale={props.defaultLocale}
                                      rolesDataSource={props.rolesDataSource}
                                      onClose={props.onClose}
                                      onSave={handleOnSave}/>
            );
        }
    };

    return <div id={generateIdentifier()}>{renderDialogs()}</div>;
};
